import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.GeneralAlarmInput
 * The DEFA GeneralAlarmInput model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	wiredalarm: '/wiredAlarmInput/iasZone?attrs=',
};

const GeneralAlarmInput = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.wiredalarm + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			// General alarm input
			alarmMask: null,
			alarmMaskError: null,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			
			if(response.alarmMask){
				this.parseAttribute('alarmMask', response.alarmMask, options, newModelAttributes);
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'generalAlarmInputs' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return {
			alarmMask: {
				intruderAlarm: 'ON' === this.get('generalAlarmInputSwitch'),
			},
		};
	},
	
	getAttributes: function() {
		return 'alarmMask';
	},
	
} );

export default GeneralAlarmInput;
